__webpack_require__.p = "https://cdn.brandwatch.com/shared-dashboard-wrapper/792d061d3d1beb5b056c177c55a141d418451045/";